import * as React from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import { ListItemButton } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate, NavLink } from "react-router-dom";
import { NAVIGATION_ITEMS } from "../../../constants/Constants";
import { MenuItemEntity } from "../../../entities/UIEntities/MenuItem";
import { CLIENT_ROUTES, MENU_ITEMS, ROLES_NAMES, SCOPE_TYPE, ROLES_HIERARCHY } from "../../../enums/Enums";
import Icons from "../../../resources/icons/Icons";
import UtronLogo from "../UtronLogo";
import classes from "./SideBar.module.css";

import { commonActions } from "../../../redux/reducers/CommonReducer"; // added
import store from "../../../redux/Store"; // added
import { useEffect } from "react";
import CustomMenu from "../Menus/CustomMenu/CustomMenu";
import { getSitesUnderSelectedScope, isAllowedForAdminArea } from "../../../utils/UsersUtils";

export default function SideBar() {
  let gmtUser = useSelector((state) => state.user.gmtUser);
  const allScopes = useSelector((state) => state.user?.allScopes);
  const sites = useSelector((state) => state.user?.sites);
  const roles = useSelector((state) => state?.user?.initialState?.roles);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const selectedSites = getSitesUnderSelectedScope(sites, allScopes, selectedScope);
  let isChargeAccount = gmtUser?.userIdentity?.userScopes?.some(us => us?.role?.name === ROLES_NAMES.CHARGE_ACCOUNT);
  let navigate = useNavigate();
  //const [navItems, setNavItems] = React.useState(isChargeAccount ? NAVIGATION_ITEMS.filter(navItem => navItem.link === CLIENT_ROUTES.VALIDATIONS) : NAVIGATION_ITEMS.filter(navItem => navItem.link !== CLIENT_ROUTES.VALIDATIONS));

  // if charge account -show only validations 
  // if normal user - remove validations & admin & messages
  const [navItems, setNavItems] = React.useState(isChargeAccount ? NAVIGATION_ITEMS.filter(navItem => navItem.link === CLIENT_ROUTES.VALIDATIONS || navItem.link === CLIENT_ROUTES.HISTORY) : NAVIGATION_ITEMS.filter(navItem => navItem.link !== CLIENT_ROUTES.VALIDATIONS && navItem.link !== CLIENT_ROUTES.HISTORY && navItem.link !== CLIENT_ROUTES.ADMIN && navItem.link !== CLIENT_ROUTES.MESSAGING));

  // const adminNavMenu = new NavItemEntity(
  //   PAGES.ADMIN,
  //   CLIENT_ROUTES.ADMIN,
  //   Icons.ADMIN,
  //   Icons.ADMIN2
  // );
  
  const menuItems = [
    new MenuItemEntity(
      MENU_ITEMS.GMT_USER_MANAGEMENT,
      () => {
        return navigate(CLIENT_ROUTES.ADMIN)
      },
      true,
      Icons.MY_PROFILE,
      false,
      {}
    ),
    new MenuItemEntity(
      MENU_ITEMS.WORKSPACE_CONFIGURATION,
      () => {
        return navigate(CLIENT_ROUTES.WORKSPACE)
      },
      true,
      Icons.WORKSPACE_COFIGURATION,
      false,
      {}
    ),
  ];
  
  useEffect(() => {
    if (selectedScope !== null) {
      let isAdminAreaVisible = isAllowedForAdminArea(gmtUser?.userIdentity?.userScopes, selectedScope, allScopes, roles);
      let isMessagingAreaVisible = isAdminAreaVisible && (selectedScope?.type === SCOPE_TYPE.PROJECT && selectedSites?.some(se => se?.isMessagingEnabled));
      let updatedList = NAVIGATION_ITEMS;
      
      // refilter - to add admin route / messaging route
      if (isAdminAreaVisible) {
        if (isMessagingAreaVisible) {
          // show both admin area and messaging area
          updatedList = updatedList.filter(navItem => navItem.link !== CLIENT_ROUTES.VALIDATIONS && navItem.link !== CLIENT_ROUTES.HISTORY);
          updatedList.find(navItem => navItem.link === CLIENT_ROUTES.MESSAGING).isActive = false;
        }
        else {
          // show only admin area
          updatedList = updatedList.filter(navItem => navItem.link !== CLIENT_ROUTES.VALIDATIONS && navItem.link !== CLIENT_ROUTES.HISTORY && navItem.link !== CLIENT_ROUTES.MESSAGING);
        }

        updatedList.find(navItem => navItem.link === CLIENT_ROUTES.ADMIN).isActive = false;
        setNavItems(updatedList);
      }
      else {
        // show all except admin area
        updatedList = updatedList.filter(navItem => navItem.link !== CLIENT_ROUTES.VALIDATIONS && navItem.link !== CLIENT_ROUTES.HISTORY && navItem.link !== CLIENT_ROUTES.MESSAGING && navItem.link !== CLIENT_ROUTES.ADMIN);
        setNavItems(updatedList);
      }

      // if (isAdminAreaVisible) {
      //   updatedList = updatedList.filter(navItem => navItem.link !== CLIENT_ROUTES.VALIDATIONS && navItem.link !== CLIENT_ROUTES.MESSAGING);
      //   updatedList.find(navItem => navItem.link === CLIENT_ROUTES.ADMIN).isActive = false;
      //   setNavItems(updatedList);
      // }
    }
  }, [selectedScope]);

  useEffect(() => {
    var index = navItems.indexOf(navItems.filter((navigationItem) => navigationItem.link === window.location.pathname)[0]);
    linkChangeHandle(index);
  }, [window.location.pathname]);

  const linkChangeHandle = (index) => {
    let navItemsCopy = [...navItems];
    
    // set IsFirstTimeLoading - true - except Validations
    if (navItemsCopy[0].link !== CLIENT_ROUTES.VALIDATIONS) {
      store.dispatch(commonActions.setIsFirstTimeLoading(true)); // added
    }

    //store.dispatch(commonActions.setIsFirstTimeLoading(true)); // added

    navItemsCopy.map((navItem, i) =>
      i === index ? (navItem.isActive = true) : (navItem.isActive = false)
    );

    setNavItems(navItemsCopy);
  };

  return (
    <div className={classes.sideBar}>
      <Drawer
        classes={{ paper: classes.paper, root: classes.sideBarRoot }}
        variant="permanent"
        anchor="left"
        >
        <div className={classes.sideBarDrawer}>
        
          <Toolbar className={classes.logo}>
            <UtronLogo />
          </Toolbar>

          <List>
            {navItems.map((navItem, index) => (
              // remove billing / messaging when not allowed
              navItem.link === CLIENT_ROUTES.BILLING && !selectedSites?.some(se => se?.isBillingEnabled) ||
              navItem.link === CLIENT_ROUTES.MESSAGING && (selectedScope?.type !== SCOPE_TYPE.PROJECT || !selectedSites?.some(se => se?.isMessagingEnabled)) ? null :
              <NavLink
                className={(navData) => {
                  //navItem.isActive = navData.isActive;
                  return navData.isActive
                    ? `${classes.link} ${classes.active}`
                    : classes.link;
                }}
                to={navItem.link}
                key={index}
                value={index}
                state={{ key: index }}
                onClick={() => linkChangeHandle(index)}
              >
                <ListItemButton className={classes.sideBarItem}>
                  {!navItem.isActive && <img src={navItem.icon} />}
                  {navItem.isActive && <img src={navItem.activeIcon} />}
                  <ListItemText
                    style={{ fontWeight: "bold" }}
                    className={classes.linkText}
                  >
                    {navItem.name}
                  </ListItemText>
                </ListItemButton>
              </NavLink>
            ))}
            {/* With Workspace */}
            {/* {gmtUser?.role?.hierarchy === ROLES_HIERARCHY.ADMINISTRATOR ? 
            navItems.map((navItem, index) => {
              if (navItem?.link === CLIENT_ROUTES.ADMIN) {
                return (
                  <ListItemButton key={index} className={classes.sideBarItem}>
                     <CustomMenu menuItems={menuItems} icon={navItems[4].icon} isSideBarMode={true}></CustomMenu>
                  </ListItemButton>
                )
              } else {
                return (<NavLink
                  className={(navData) => {
                    //navItem.isActive = navData.isActive;
                    return navData.isActive
                      ? `${classes.link} ${classes.active}`
                      : classes.link;
                  }}
                  to={navItem.link}
                  key={index}
                  value={index}
                  state={{ key: index }}
                  onClick={() => linkChangeHandle(index)}
                >
                  <ListItemButton className={classes.sideBarItem}>
                    {!navItem.isActive && <img src={navItem.icon} />}
                    {navItem.isActive && <img src={navItem.activeIcon} />}
                    <ListItemText
                      style={{ fontWeight: "bold" }}
                      className={classes.linkText}
                    >
                      {navItem.name}
                    </ListItemText>
                  </ListItemButton>
                </NavLink>)
              }
            }): 
              navItems.map((navItem, index) => (
              <NavLink
                className={(navData) => {
                  //navItem.isActive = navData.isActive;
                  return navData.isActive
                    ? `${classes.link} ${classes.active}`
                    : classes.link;
                }}
                to={navItem.link}
                key={index}
                value={index}
                state={{ key: index }}
                onClick={() => linkChangeHandle(index)}
              >
                <ListItemButton className={classes.sideBarItem}>
                  {!navItem.isActive && <img src={navItem.icon} />}
                  {navItem.isActive && <img src={navItem.activeIcon} />}
                  <ListItemText
                    style={{ fontWeight: "bold" }}
                    className={classes.linkText}
                  >
                    {navItem.name}
                  </ListItemText>
                </ListItemButton>
              </NavLink>
            ))
            }         */}
                       
          </List>
        </div>
      </Drawer>
    </div>
  );
}
